import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../components/procedure/selectors'
import { setInputRows } from '../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../components/procedure/store/procedure.types'
import { getIntubationSelector } from '../selectors'
import { IntubationConstants } from '../store/intubation.constants'
import { IIntubationState } from '../store/intubation.types'
import { IPNNVOption } from '../../../common/common.types'

export interface IAirwayComplicationPNNVAction {
  type: string
  airwayPlacementTechniquePNNV: IPNNVOption | null
}

export function* setAirwayPlacementTechniquePNNV(action: IAirwayComplicationPNNVAction) {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const intubationState: IIntubationState = yield select(getIntubationSelector)
  const { inputRows } = procedureState
  const { airwayPlacementTechnique } = intubationState

  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === IntubationConstants.SET_AIRWAY_PLACEMENT_TECHNIQUE) {
        //@ts-ignore
        input.props.savedValues = airwayPlacementTechnique
        //@ts-ignore
        input.props.savedPNNVValue = action.airwayPlacementTechniquePNNV
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setAirwayPlacementTechniquePNNVSaga() {
  yield takeLatest([IntubationConstants.SET_AIRWAY_PLACEMENT_TECHNIQUE_PNNV], setAirwayPlacementTechniquePNNV)
}
